import React from "react";
import Navbar from "../Navbar";
import { Helmet } from "react-helmet";
import Footer from '../components/Footer';
import CookiesBanner from '../components/CookiesBanner';

function PoliticaCookies() {
  return (
    <>
    <Helmet>
        <title>Política de Cookies</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", lineHeight: "1.6",fontSize: "16px"   }}>


      <h1>Política de Cookies</h1>
      <p>
  La presente política tiene como finalidad informarte de manera clara y precisa sobre las cookies que se utilizan en nuestro sitio web www.avisamesibaja.com, de conformidad con la normativa vigente.
</p>

      <p>
        Esta web utiliza cookies propias y de terceros para mejorar tu
        experiencia de navegación y analizar el uso del sitio web.
      </p>
      <p>
  Al acceder por primera vez al sitio, te mostramos un banner de cookies donde puedes aceptar o rechazar el uso de cookies no esenciales. Tus preferencias pueden modificarse en cualquier momento desde el enlace “Cambiar preferencias de cookies” en el pie de página.
</p>
<p>
  <strong>Ninguna cookie o tecnología de seguimiento no esencial se carga antes de que des tu consentimiento.</strong> Las herramientas de análisis, publicidad y grabación de sesión descritas más abajo se activan únicamente después de que pulses “Aceptar”. Si rechazas, o si aún no has decidido, no se cargan.
</p>

      <h2>¿Cómo puedes configurar o desactivar tus cookies?</h2>
<p>
  Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuración de las opciones del navegador instalado en tu dispositivo.
</p>
<ul>
  <li><a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
  <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
  <li><a href="https://support.apple.com/es-es/HT201265" target="_blank" rel="noopener noreferrer">Safari (Apple)</a></li>
  <li><a href="https://support.microsoft.com/es-es/topic/Descripción-de-las-cookies-en-internet-explorer-9-7c63ec4f-2d52-4fa5-8f52-e0c9028e03c4" target="_blank" rel="noopener noreferrer">Internet Explorer / Edge</a></li>
</ul>


      <h2>¿Qué tipos de cookies utilizamos?</h2>

      <ul>
        <li>
          <strong>Cookies técnicas necesarias:</strong> Son imprescindibles
          para el funcionamiento básico del sitio (como la autenticación o la
          gestión de preferencias). Estas cookies no requieren tu
          consentimiento.
        </li>
        <li>
          <strong>Cookies analíticas (Google Analytics 4):</strong> Servicio de análisis web de Google LLC que nos permite conocer cómo interactúan los usuarios con nuestra web: páginas visitadas, origen del tráfico y clics en enlaces salientes. Utilizamos la anonimización de IP. Estas cookies se cargan únicamente si aceptas su uso a través del banner inicial. Más información en la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Política de privacidad de Google</a>.
        </li>
        <li>
          <strong>Cookies publicitarias (Google Ads):</strong> Utilizamos la etiqueta de conversiones de Google Ads, de Google LLC, para medir la eficacia de nuestras campañas publicitarias y atribuir los registros que se originan en ellas. Estas cookies se cargan únicamente si aceptas su uso a través del banner inicial. Más información en la <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">política de Google sobre publicidad</a>.
        </li>
        <li>
          <strong>Microsoft Clarity:</strong> Utilizamos Microsoft Clarity, de Microsoft Corporation, para analizar el comportamiento de los usuarios mediante grabaciones de sesión y mapas de calor. Registra interacciones como movimientos del ratón, clics y desplazamiento. Se carga únicamente si aceptas su uso a través del banner inicial. Más información en la <a href="https://privacy.microsoft.com/es-es/privacystatement" target="_blank" rel="noopener noreferrer">Política de privacidad de Microsoft</a>.
        </li>

      </ul>

      <p>
        Google LLC y Microsoft Corporation son proveedores establecidos fuera del Espacio Económico Europeo. Las transferencias internacionales de datos que puedan producirse se amparan en el Marco de Privacidad de Datos UE-EE. UU. y en las cláusulas contractuales tipo aprobadas por la Comisión Europea.
      </p>

      <p>
        Puedes aceptar o rechazar estas cookies desde el banner inicial del
        sitio. También puedes modificar tus preferencias en cualquier momento
        desde la configuración de tu navegador.
      </p>

      <p>
        Para más información sobre cómo Google trata los datos recopilados a
        través de Google Analytics, puedes consultar su{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Política de Privacidad
        </a>
        .
      </p>
      <h2>Actualizaciones</h2>
<p>Nos reservamos el derecho a modificar esta política de cookies en cualquier momento. Cualquier cambio significativo será notificado en el sitio web.</p>

      <p style={{ fontSize: "0.9em", marginTop: "2rem", color: "#555" }}>
  Última actualización: agosto de 2026
</p>

    </div>
    <Footer />
      <CookiesBanner />
    </>
  );
}

export default PoliticaCookies;
